import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Input } from '@/components/ui/input';

interface GoalsConfigProps {
  enabled: boolean;
  maxGoals: number;
  onEnabledChange: (enabled: boolean) => void;
  onMaxGoalsChange: (max: number) => void;
}

export function GoalsConfig({
  enabled,
  maxGoals,
  onEnabledChange,
  onMaxGoalsChange,
}: GoalsConfigProps) {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <Label htmlFor="goals-enabled">Metas de Negócio</Label>
          <p className="text-sm text-muted-foreground">
            Permite configurar metas de MRR, ARR, etc.
          </p>
        </div>
        <Switch
          id="goals-enabled"
          checked={enabled}
          onCheckedChange={onEnabledChange}
        />
      </div>

      {enabled && (
        <div className="space-y-2 p-4 border rounded-lg bg-muted/50">
          <Label htmlFor="max-goals">Máximo de Metas Simultâneas</Label>
          <Input
            id="max-goals"
            type="number"
            min="0"
            value={maxGoals}
            onChange={(e) => onMaxGoalsChange(parseInt(e.target.value) || 0)}
            placeholder="Ilimitado"
          />
          <p className="text-xs text-muted-foreground">
            {maxGoals === 0
              ? 'Sem limite de metas'
              : `O Admin poderá criar até ${maxGoals} meta(s) simultânea(s)`}
          </p>
        </div>
      )}
    </div>
  );
}
